var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewwallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83331 4V11.3333C1.83331 12.6666 2.49998 13.3333 3.83331 13.3333H13.1666C14.5 13.3333 15.1666 12.6666 15.1666 11.3333V5.99994C15.1666 5.63174 14.868 5.33328 14.5 5.33328C10.7222 5.33328 6.94443 5.33305 3.16665 5.33325C2.43028 5.33328 1.83331 4.73636 1.83331 4ZM11.8333 7.99994C12.2013 7.99994 12.5 8.29841 12.5 8.66661C12.5 9.03481 12.2013 9.33328 11.8333 9.33328C11.4653 9.33328 11.1666 9.03481 11.1666 8.66661C11.1666 8.29841 11.4653 7.99994 11.8333 7.99994Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16665 2.66663C2.43027 2.66663 1.83331 3.26358 1.83331 3.99996C1.83331 4.73634 2.43027 5.33329 3.16665 5.33329C6.7222 5.33329 10.2778 5.33329 13.8333 5.33329V3.33329C13.8333 2.9651 13.5348 2.66663 13.1666 2.66663H3.16665Z",
    fill: "white",
    fillOpacity: 0.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewwallet);
export default __webpack_public_path__ + "static/media/newwallet.654c4147999907c99197bf3217e64b50.svg";
export { ForwardRef as ReactComponent };